<template>
  <div>
     <h5 class="drawer-sub-title mb-15 mt-0">
      <svgicon name="left_arrow" class="pointer" width="16" height="11"  @click="$emit('closeItemView')"/>
      <span class="ml-5">{{config && config.name}}</span>
      <div class="f-right">
        <Button type="text" size="mini" @click="downloadDocumentation()">{{$t('INDENT_DOWNLOAD')}}</Button>
        <Button v-if="!isReadOnlyUser" type="text" size="mini" @click="printDocumentation()">{{$t('INDENT_PRINT_SELECTED')}}</Button>
        <Button type="text" size="mini" @click="loadItemDetails()">{{$t('INDENT_REFRESH')}}</Button>
      </div>
    </h5>
    <div class="w-400">
      <Input :placeholder="$t('INDENT_SEARCH_BY_ITEM')" size="mini" class="input-search no-border"
        v-model="query" @input="search">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </Input>
    </div>
     <div class="content-scroll-inner space-top mx-pd-15" style="width:800px">
    <!-- <div class="status-msg my-md" v-if="isitemLoading">Loading...</div> -->
    <div
      >
        <div class="status-msg my-md" v-if="!itemAttachments || !itemAttachments.length">
          <span>
            <svgicon name="empty-materials" width="250" height="120" :original="true" />
            <p>{{$t('INDENT_NO_DOCUMENT_GENERATED')}}</p>
          </span>
        </div>
        <!-- start of item level docs -->
        <TagwithAttachment
          v-else
          :documentsList="itemAttachments"
          :defaultCopies="config.default_copies || 1"
          :selectedDocuments="selectedDocuments"
          :selectedConfig="config"
          @selectDocument="selectSingleDocument"
          @changeCopiesNumber="changeCopies"
          printLevel="item"
        ></TagwithAttachment>
        <!-- end of item level docs -->
        <infinite-loading @infinite="loadItemDetails"  slot="append">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>
<script>
import { uniqBy, orderBy } from 'lodash';
import { mapGetters, mapState } from 'vuex';
import debounce from 'debounce';
import TagwithAttachment from '@/components/orders/TagwithAttachment';
import DocumentCountBadge from '@/components/orders/DocumentCountBadge';

import PrintDocumentsMixin from '@/components/orders/mixins/PrintDocumentsMixin';

export default {
  components: {
    TagwithAttachment,
    DocumentCountBadge,
  },
  props: ['deliveryId', 'orderNumber', 'config', 'isReadOnlyUser'],
  mixins: [PrintDocumentsMixin],
  data() {
    return {
      numeric: null,
      documentsConfig: [],
      indentDocuments: [],
      isLoadingData: false,
      selectedDocuments: [],
      checked: false,

      // documents list
      query: null,
    };
  },
  created() {
    this.selectedDocuments = [];
    this.$store.commit('order/INIT_SUB_DELIVERY_DETAILS');
    // this.loadItemDetails();
  },
  computed: {
    ...mapGetters({
      itemPageCount: 'order/subDeliveryPage',
      itemAttachments: 'order/subDeliveryDetails',
      hasEmpty: 'order/hasEmptySubDeliveryList',
      isitemLoading: 'order/isSubDeliveryLoading',
    }),
  },
  methods: {
    changeCopies(document, value, index) {
      const details = this.itemAttachments[index];
      details.default_copies = value;
      this.$store.commit('order/SET_SUB_DELIVERY_DETAIL', { data: details, index });
      this.changeCopiesNumber(document, value);
    },
    async loadItemDetails($state = null) {
      if (!this.isitemLoading) {
        try {
          const params = {
            printing_level: 'item',
            page_number: this.itemPageCount,
            document_type: this.config.key,
            delivery_id: this.deliveryId,
            search: true,
          };
          if (this.query) {
            params.item_id = this.query;
          }
          const result = await this.$store.dispatch(
            'order/getPackingDocuments',
            params,
          );
          if (!result || result.error) {
            $state.complete();
            this.$errorMessage({ message: this.$t('INDENT_DOCUMENTS_FETCHING_FAILED') });
          }
        } catch (err) {
          $state.complete();
          this.$errorMessage({ message: this.$t('INDENT_DOCUMENTS_FETCHING_FAILED') });
        }
        if ($state) {
          if (!this.hasEmpty) {
            $state.loaded();
          } else {
            $state.complete();
          }
        }
      }
    },
    search: debounce(function debounceSearch() {
      this.$store.commit('order/SET_SUB_DELIVERY_PAGE', 1);
      this.loadItemDetails();
    }, 500),
  },
};
</script>
